export var S51Config = {
    "dev":{
        HUMAN_URL:"https://xiaochengxu.studio51.com",
        HUMAN_SIGN:"studio51"
    },
    "pro":{
        HUMAN_URL:"https://xiaochengxu.studio51.com",
        HUMAN_SIGN:"studio51"
    }
}


// WEBPACK FOOTER //
// ./src/S51WebGLSDK/utils/config.js